import { Modal } from 'antd';

export function RequestOwnWHModal({ isModalVisible = true, setIsModalVisible }) {
	const closeModal = () => setIsModalVisible(false);

	return (
		<Modal title="Add own Warehouse" open={isModalVisible} okText="Yes" onCancel={closeModal}>
			Coming Soon!
		</Modal>
	);
}
